module.exports = __webpack_public_path__ + "account/assets/assessment.b75fc25b.svg";